//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Moment from "moment";
var BASE_URL = "/prototype/global-reporting";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    return {
      startOfMonth: Moment().startOf("month").toDate(),
      endOfMonth: Moment().endOf("month").toDate(),
      headers: ["Property", "User", "Leases", "Renewals", "0% - 1%", "1% - 2%", "2% - 3%", "3% - 4%", "4% - 5%", "+5%"],
      fields: ["Property", "User", "Leases", "Renewals", "0% - 1%", "1% - 2%", "2% - 3%", "3% - 4%", "4% - 5%", "+5%"],
      items: [],
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    Event.$on("sales-commission-report", function () {
      _this.$children[0].showModal = true;
      _this.load();
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("sales-commission-report");
  },

  methods: {
    timeRangeChange: function timeRangeChange(_ref) {
      var start_date = _ref.start_date,
          end_date = _ref.end_date;

      this.startOfMonth = start_date.toDate();
      this.endOfMonth = Moment(end_date).endOf("month").format("YYYY-MM-DD");
      this.load();
    },
    load: function load() {
      var _this2 = this;

      this.items = [];
      this.loading = true;
      axios.post(BASE_URL + "/sales-commission-report", {
        start_date: Moment(this.startOfMonth).format("YYYY-MM-DD"),
        end_date: Moment(this.endOfMonth).format("YYYY-MM-DD")
      }).then(function (response) {
        _this2.items = response.data;
        _this2.loading = false;
      });
    },
    exportReport: function exportReport() {
      this.loading = true;

      var data = {
        exportExcel: true,
        start_date: Moment(this.startOfMonth).format("YYYY-MM-DD"),
        end_date: Moment(this.endOfMonth).format("YYYY-MM-DD")
      };

      this.createExport(data, BASE_URL + "/sales-commission-report", "sales-commission-report", ".xlsx");

      this.loading = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reporting/SalesCommissionReport.vue
// module id = H+UV
// module chunks = 0 1